import React, { memo, useMemo, useState } from 'react'
import styled from 'styled-components'
import { Expression } from '~/prix/types/expression'
import { FilteredType } from './filter'

const InputWrapper = styled.div`
  flex: 1;
  min-width: 0;
  height: 2.6rem;

  input {
    width: 100%;
    height: 100%;
    padding: 0.5rem;
    border: 1px solid #e6e6e6;
    color: #999999;
    background-color: #ffff;
    border-radius: 5px;
  }

  .disabled {
    background-color: #f2f2f2;
  }
`

interface FilterInputProps {
  expression: Expression
  addToExpression: (expression: FilteredType, isBetween?: boolean) => void
  value: string | undefined
  sideOfExpression?: 'left' | 'right'
}

const FilterInput = ({
  expression,
  addToExpression,
  value,
  sideOfExpression,
}: FilterInputProps) => {
  const [isDisabled, setIsDisabled] = useState(false)
  const hasValue = useMemo(() => {
    if (value) {
      return true
    }
    return false
  }, [value])

  const checkDisabled = () => {
    if (hasValue) {
      return true
    }
    return isDisabled
  }

  const handleKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (
      event.key === 'Enter' &&
      expression.kind === 'binary' &&
      expression.left.kind === 'property' &&
      (expression.operator === 'BETWEEN' || expression.operator === 'NOT BETWEEN')
    ) {
      const typeOfPreviousProperty = expression.left.literalType
      const newExpression = {
        value: {
          [sideOfExpression as string]: {
            kind: 'literal',
            type: 'expression',
            literalType: typeOfPreviousProperty,
            value: (event.target as HTMLInputElement).value,
          },
        },
      }
      addToExpression(newExpression, true)
      setIsDisabled(true)
      return
    }
    if (
      event.key === 'Enter' &&
      expression.kind === 'binary' &&
      expression.left.kind === 'property'
    ) {
      const typeOfPreviousProperty = expression.left.literalType
      const newExpression = {
        value: {
          kind: 'literal',
          type: 'expression',
          literalType: typeOfPreviousProperty,
          value: (event.target as HTMLInputElement).value,
        },
      }

      addToExpression(newExpression as FilteredType)
      setIsDisabled(true)
    }
  }
  return (
    <InputWrapper>
      <input
        onKeyDown={handleKeyPress}
        disabled={checkDisabled()}
        value={value}
        className={checkDisabled() ? 'disabled' : ''}
      />
    </InputWrapper>
  )
}

export default memo(FilterInput)
